import { useTranslation } from 'react-i18next';

const ModalFoot = ({ handleCancel, handleOk, classname }: { handleCancel: Function, handleOk: Function, classname?: string }) => {
    const { t } = useTranslation()
    return <div className='box-border border-t border-e2 flex items-center justify-between h-14 text-base'>
        <button
            onClick={() => handleCancel()}
            className='w-1/2 h-full text-86 border-r border-e2 rounded-0.3125 font-medium'
        >
            {t('com.cancel')}
        </button>
        <button
            onClick={() => { handleOk() }}
            className={`w-1/2 h-full rounded-0.3125  font-medium ${classname}`}
        >
            {t('com.confirm')}
        </button>
    </div>
}

export default ModalFoot